/**
 * Vegemite carousel
 */
var Carousel = /** @class */ (function () {
    function Carousel(element) {
        this.currentSlideID = null;
        this.previousSlideID = null;
        this.slideDuration = 8000;
        this.maxWidth = 0;
        this.slideTimer = null;
        this.parent = element;
        this.container = this.parent.querySelector('.slider');
        this.slides = this.container.querySelectorAll('.slide');
        this.buttons = this.getButtons();
        this.slideContents = this.parent.querySelectorAll('.slide-content');
        this.initialised = false;
        if (element.hasAttribute("data-duration")) {
            this.slideDuration = parseInt(element.getAttribute("data-duration"));
        }
        if (element.hasAttribute("data-maxwidth")) {
            this.maxWidth = parseInt(element.getAttribute("data-maxwidth"));
        }
        this.attachButtons();
        this.nextSlide();
    }
    Carousel.prototype.getButtons = function () {
        var buttons = this.parent.querySelectorAll('.slide-button');
        //Generate some html if there are no controls present
        if (buttons.length == 0 && this.slides.length > 1 && !this.parent.querySelector('.slider-controls')) {
            var sliderControls = document.createElement('DIV');
            sliderControls.className = 'slider-controls';
            var sliderControlsContent = document.createElement('DIV');
            sliderControlsContent.className = 'controls-content';
            sliderControls.appendChild(sliderControlsContent);
            for (var i = 0; i < this.slides.length; i++) {
                var button = document.createElement('BUTTON');
                button.className = 'slide-button';
                button.setAttribute('data-slidenumber', i.toString());
                sliderControlsContent.appendChild(button);
            }
            this.parent.appendChild(sliderControls);
            buttons = this.getButtons();
        }
        return buttons;
    };
    Carousel.prototype.nextSlide = function () {
        var _this = this;
        //Set up the next slide call
        if (this.slides.length > 1) {
            this.slideTimer = setTimeout(function () {
                _this.nextSlide();
            }, this.slideDuration);
        }
        //If it's a mobile only carousel dont go to next slide if it's over the max width
        if (this.initialised && this.maxWidth > 0) {
            var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (winWidth > this.maxWidth) {
                return; //skip the rest of this function
            }
        }
        //Switch slides
        if (this.currentSlideID !== null) {
            this.switchTo(this.currentSlideID + 1);
        }
        else {
            this.switchTo(0);
        }
    };
    Carousel.prototype.loadSlide = function () {
        var _this = this;
        var slide = this.slides[this.currentSlideID];
        this.container.appendChild(slide);
        if (this.previousSlideID !== null) {
            this.slides[this.previousSlideID].classList.remove('active');
        }
        slide.classList.add('next-up');
        setTimeout(function () {
            slide.classList.add('active');
            slide.classList.remove('next-up');
            if (_this.previousSlideID !== null) {
                _this.slides[_this.previousSlideID].classList.remove('active');
            }
            if (slide.classList.contains('dark')) {
                _this.parent.classList.add('dark');
            }
            else {
                _this.parent.classList.remove('dark');
            }
            if (slide.classList.contains('fullwidth')) {
                _this.parent.classList.add('fullwidth');
            }
            else {
                _this.parent.classList.remove('fullwidth');
            }
            if (slide.classList.contains('opaquebutton')) {
                _this.parent.classList.add('opaquebutton');
            }
            else {
                _this.parent.classList.remove('opaquebutton');
            }
            _this.parent.querySelectorAll('video').forEach(function (video) {
                video.pause();
                video.currentTime = 0;
            });
            slide.querySelectorAll('video').forEach(function (video) {
                if (!_this.isHidden(video)) {
                    video.play();
                }
            });
        }, 200);
        this.buttons.forEach(function (button) {
            var id = parseInt(button.getAttribute('data-slidenumber'));
            if (id === _this.currentSlideID) {
                button.classList.add('active');
            }
            else {
                button.classList.remove('active');
            }
        });
        this.slideContents.forEach(function (slideContent) {
            var id = parseInt(slideContent.getAttribute('data-slidenumber'));
            if (id === _this.currentSlideID) {
                slideContent.parentElement.appendChild(slideContent);
                setTimeout(function () {
                    slideContent.classList.add('active');
                }, 500);
            }
            else {
                slideContent.classList.remove('active');
            }
        });
        this.initialised = true;
    };
    Carousel.prototype.switchTo = function (id) {
        if (id === this.currentSlideID) {
            return;
        }
        if (this.currentSlideID !== null) {
            this.previousSlideID = this.currentSlideID;
            this.currentSlideID = id;
            if (this.currentSlideID >= this.slides.length) {
                this.currentSlideID = 0;
            }
        }
        else {
            this.currentSlideID = 0;
        }
        this.loadSlide();
    };
    Carousel.prototype.stop = function () {
        if (this.slideTimer !== null) {
            clearTimeout(this.slideTimer);
        }
    };
    Carousel.prototype.attachButtons = function () {
        var _this = this;
        this.buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                var id = parseInt(button.getAttribute('data-slidenumber'));
                _this.stop();
                _this.switchTo(id);
            });
        });
    };
    Carousel.prototype.isHidden = function (element) {
        var style = window.getComputedStyle(element);
        return (style.display === 'none');
    };
    return Carousel;
}());
window.addEventListener("load", function () {
    var carousels = document.querySelectorAll('.carousel-2pi');
    carousels.forEach(function (carousel) {
        new Carousel(carousel);
    });
});
